import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from "@sentry/react";
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {Integrations} from "@sentry/tracing";
import {Provider} from "react-redux";
import store from "./store/store";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

const SW_UNREGISTER_RELOAD_KEY = "ck:sw-unregister-reload";

Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    integrations: [new Integrations.BrowserTracing()],
    tracesSampleRate: 0.05,
    environment: process.env.REACT_APP_ENV
});

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);
root.render(
    // <React.StrictMode>
        <Provider store={store}>
            <App/>
        </Provider>
    // </React.StrictMode>
);

if ("serviceWorker" in navigator) {
    navigator.serviceWorker.getRegistrations().then((registrations) => {
        if (!registrations.length) {
            sessionStorage.removeItem(SW_UNREGISTER_RELOAD_KEY);
            return;
        }

        Promise.all(registrations.map((registration) => registration.unregister()))
            .then((results) => {
                const didUnregister = results.some(Boolean);

                if (
                    didUnregister &&
                    navigator.serviceWorker.controller &&
                    !sessionStorage.getItem(SW_UNREGISTER_RELOAD_KEY)
                ) {
                    sessionStorage.setItem(SW_UNREGISTER_RELOAD_KEY, "true");
                    window.location.reload();
                    return;
                }

                sessionStorage.removeItem(SW_UNREGISTER_RELOAD_KEY);
            })
            .catch((error) => {
                console.error("Error while unregistering service workers:", error);
            });
    });
}

serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
